import { createClient } from "@supabase/supabase-js";
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;

export const apiCall = createClient(SUPABASE_URL, SUPABASE_KEY);
